import axios from "axios";

const http = axios.create({
  baseURL: "http://20.193.159.183:8003/api/v1",
  // baseURL: "http://localhost:8005/api/v1",
});

export default http;
